import { Injectable } from '@angular/core';
import {
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateFn
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/auth.service';

// ✅ Functional guard (estilo moderno Angular 17)
export const AuthGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const authService = inject(AuthenticationService);
	const router = inject(Router);

	// ✅ Lee desde el signal del servicio, no del localStorage
	if (authService.isAuthenticated()) {
		return true;
	}

	// ✅ El servicio se encarga de limpiar, el guard solo redirige
	authService.logout();
	return false;
};